import type { IQuestionsPageProps } from '$/pages/registration/questions';

import React from 'react';

import QuestionsPageView from './QuestionsPageView';
import useQuestionsPage from './useQuestionsPage';

const QuestionsPage = (props: IQuestionsPageProps) => {
  const state = useQuestionsPage(props);
  return <QuestionsPageView {...props} {...state} />;
};

export default QuestionsPage;
